import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MarketingCampaignState } from "./types";
import { fetchMarketingCampaign, fetchMarketingCampaignStatistics, fetchParticipations, fetchParticipationsCount, fetchPrizes, fetchRegistrationsCount } from "./marketing-campaign-thunk";
import { ErrorType } from "@/shared/types";

const initialState: MarketingCampaignState = {
    isLoading: false,
    error: null,
    campaign: {
        id: "",
        name: "",
        bot_id: "",
        invitation_id: "",
        start_date: "1970-01-01T00:00:00.000Z",
        end_date: "1970-01-01T00:00:00.000Z",
        prizes: [],
        limit: 0,
        events: [],
        total_activated: 0,
        is_finished: false,
        is_active: false,
        is_draw: false,
        auto_post_results: false,
        auto_post_channel: null
    },

    prizes: [],
    isPrizesLoading: false,
    isPrizesFirstLoad: true,
    prizesError: null,
    prizesPage: 1,
    prizesLimit: 50,
    prizesTotalPages: 0,

    participations: [],
    isParticipationsFirstLoad: true,
    isParticipationsLoading: false,
    participationsError: null,
    participationsLimit: 50,
    participationsPage: 1,
    participationsTotalPages: 0,

    campaignStatistics: [],
    participationsCount: 0,
    registrationsCount: 0,
    campaignPrizeStatistics: []
}

const marketingCampaignSlice = createSlice({
    name: 'marketingCampaign',
    initialState,
    reducers: {
        setPrizesPage: (state, action: PayloadAction<number>) => {
            state.prizesPage = action.payload
        },
        setParticipationsPage: (state, action: PayloadAction<number>) => {
            state.participationsPage = action.payload
        }
    },
    extraReducers(builder) {
        builder
        .addCase(fetchMarketingCampaign.pending, (state) => {
            state.isLoading = true
        })
        .addCase(fetchMarketingCampaign.fulfilled, (state, action) => {
            state.campaign = action.payload
            state.error = null
            state.isLoading = false

            state.prizes = []
            state.prizesPage = 1
            state.prizesTotalPages = 0
            state.isPrizesFirstLoad = true
            state.prizesError = null

            state.participations = []
            state.participationsPage = 1
            state.participationsTotalPages = 0
            state.isParticipationsFirstLoad = true
            state.participationsError = null

            state.participationsCount = 0
            state.campaignStatistics = []
        })
        .addCase(fetchMarketingCampaign.rejected, (state, action) => {
            state.error = action.payload as ErrorType
            state.isLoading = false
        })
        .addCase(fetchPrizes.pending, (state) => {
            state.isPrizesLoading = true
        })
        .addCase(fetchPrizes.fulfilled, (state, action) => {
            state.prizesError = null
            state.prizes = action.payload.items
            state.isPrizesFirstLoad = false
            state.isPrizesLoading = false
            state.participationsTotalPages = action.payload.totalPages
        })
        .addCase(fetchPrizes.rejected, (state, action) => {
            state.isPrizesLoading = false
            state.prizesError = action.payload as ErrorType
        })
        .addCase(fetchParticipations.pending, (state) => {
            state.isParticipationsLoading = true
        })
        .addCase(fetchParticipations.fulfilled, (state, action) => {
            state.participationsError = null
            state.participations = action.payload.items
            state.isParticipationsFirstLoad = false
            state.isParticipationsLoading = false
            state.participationsTotalPages = action.payload.totalPages
        })
        .addCase(fetchParticipations.rejected, (state, action) => {
            state.isParticipationsLoading = false
            state.participationsError = action.payload as ErrorType
        })
        .addCase(fetchMarketingCampaignStatistics.fulfilled, (state, action) => {
            state.campaignStatistics = action.payload
        })
        .addCase(fetchParticipationsCount.fulfilled, (state, action) => {
            state.participationsCount = action.payload
        })
        .addCase(fetchRegistrationsCount.fulfilled, (state, action) => {
            state.registrationsCount = action.payload
        })
    },
})

export default marketingCampaignSlice.reducer
export const { setPrizesPage, setParticipationsPage } = marketingCampaignSlice.actions